/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Columnmenu_Sort1Inputs */

const en_columnmenu_sort1 = /** @type {(inputs: Columnmenu_Sort1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort`)
};

const de_columnmenu_sort1 = /** @type {(inputs: Columnmenu_Sort1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortieren`)
};

/**
* | output |
* | --- |
* | "Sort" |
*
* @param {Columnmenu_Sort1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const columnmenu_sort1 = /** @type {((inputs?: Columnmenu_Sort1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Columnmenu_Sort1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_columnmenu_sort1(inputs)
	return de_columnmenu_sort1(inputs)
});
export { columnmenu_sort1 as "columnMenu_sort" }